// extracted by mini-css-extract-plugin
module.exports = {"root":"Tile_root__30df4","main":"Tile_main__2cpSW"};